import { render, staticRenderFns } from "./VCar.vue?vue&type=template&id=60092e2c&scoped=true&"
import script from "./VCar.vue?vue&type=script&lang=js&"
export * from "./VCar.vue?vue&type=script&lang=js&"
import style0 from "./VCar.vue?vue&type=style&index=0&id=60092e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60092e2c",
  null
  
)

export default component.exports